<template>
	<div>
		<div class="task-wrapper">
			<div class="title page">新手任务<span class="rule-btn" @click=""><i class="iconfont icon-guizeshuoming-iconfuzhi"></i>任务规则</span></div>
			<div class="newTask">
				<div class="wrapper" v-for="item in newList">
					<!-- <div class="icon"><i class="iconfont icon-gerenziliao1"></i></div> -->
					<div>
						<div class="title">{{item.taskName}}</div>
						<div class="jifen"><span>奖励积分</span><span class="num">{{item.bonusPoints}}</span></div>
					</div>
					<div class="btn">
						<el-button type="info" size="mini" class="isdone" style="background-color: #f4f4f5;" v-if="item.isDone" disabled>已完成</el-button>
						<el-button type="warning" size="mini" class="submit" v-else @click="$router.push({path:item.router})">去完成</el-button>
					</div>
				</div>
			</div>
			
		</div>
		<div class="task-wrapper daytask">
			<div class="title page">每日任务</div>
			<!-- <div class="dayTaskList">
				<div class="wrapper" v-for="item in newList">
					<div>
						<div class="title">{{item.taskName}}</div>
						<div class="jifen"><span>奖励积分</span><span class="num">{{item.bonusPoints}}</span></div>
					</div>
					<div class="btn">
						<el-button type="info" size="mini" class="isdone" style="background-color: #f4f4f5;" v-if="item.isDone" disabled>已完成</el-button>
						<el-button type="warning" size="mini" class="submit" v-else @click="$router.push({path:item.router})">去完成</el-button>
					</div>
				</div>
			</div> -->
			<el-row :gutter="10">
			  <el-col :span="8">
				<div class="wrapper">
					<div class="icon"><i class="iconfont icon-16"></i></div>
					<div>
						<div class="title">每日发布文章</div>
						<div class="jifen"><span>积分 +10</span><span>已完成 0/2</span></div>
					</div>
					<div class="btn">
						<el-button type="warning" size="mini" class="submit" @click="$router.push({path:'/social/form'})">去发布</el-button>
					</div>
				</div>
			  </el-col>
			  <el-col :span="8">
				<div class="wrapper">
					<div class="icon"><i class="iconfont icon-tubiaopinglunshu"></i></div>
					<div>
						<div class="title">每日评论文章</div>
						<div class="jifen"><span>积分 +10</span><span>已完成 0/2</span></div>
					</div>
					<div class="btn">
						<el-button type="warning" size="mini" class="submit" @click="$router.push({path:'/social'})">去评论</el-button>
					</div>
				</div>
			  </el-col>
			  <el-col :span="8">
				<div class="wrapper">
					<div class="icon"><i class="iconfont icon-good"></i></div>
					<div>
						<div class="title">每日点赞文章</div>
						<div class="jifen"><span>积分 +10</span><span>已完成 0/2</span></div>
					</div>
					<div class="btn">
						<el-button type="warning" size="mini" class="submit" @click="$router.push({path:'/social'})">去点赞</el-button>
					</div>
				</div>
			  </el-col>
			</el-row>
			<el-row :gutter="10">
			  <el-col :span="8">
				<div class="wrapper">
					<div class="icon"><i class="iconfont icon-shoucang1"></i></div>
					<div>
						<div class="title">每日收藏文章</div>
						<div class="jifen"><span>积分 +10</span><span>已完成 0/2</span></div>
					</div>
					<div class="btn">
						<el-button type="warning" size="mini" class="submit" @click="$router.push({path:'/social'})">去收藏</el-button>
					</div>
				</div>
			  </el-col>
			  <el-col :span="8">
				<div class="wrapper">
					<div class="icon"><i class="iconfont icon-chakan"></i></div>
					<div>
						<div class="title">每日浏览文章</div>
						<div class="jifen"><span>积分 +10</span><span>已完成 0/2</span></div>
					</div>
					<div class="btn">
						<el-button type="warning" size="mini" class="submit" @click="$router.push({path:'/social'})">去浏览</el-button>
					</div>
				</div>
			  </el-col>
			  <el-col :span="8">
				<div class="wrapper">
					<div class="icon"><i class="iconfont icon-zhuanfa3"></i></div>
					<div>
						<div class="title">每日转发文章</div>
						<div class="jifen"><span>积分 +10</span><span>已完成 0/2</span></div>
					</div>
					<div class="btn">
						<el-button type="warning" size="mini" class="submit" @click="$router.push({path:'/social'})">去转发</el-button>
					</div>
				</div>
			  </el-col>
			</el-row>
			<el-row :gutter="10">
			  <el-col :span="8">
				<div class="wrapper">
					<div class="icon"><i class="iconfont icon-guanzhu"></i></div>
					<div>
						<div class="title">每日关注</div>
						<div class="jifen"><span>积分 +10</span><span>已完成 0/2</span></div>
					</div>
					<div class="btn">
						<el-button type="warning" size="mini" class="submit" @click="$router.push({path:'/social'})">去关注</el-button>
					</div>
				</div>
			  </el-col>
			  <el-col :span="8">
				<div class="wrapper">
					<div class="icon"><i class="iconfont icon-good"></i></div>
					<div>
						<div class="title">每日获得点赞数</div>
						<div class="jifen"><span>积分 +10</span><span>已完成 0/2</span></div>
					</div>
					<div class="btn">
						<el-button type="warning" size="mini" class="submit" @click="$router.push({path:'/social/form'})">去发布</el-button>
					</div>
				</div>
			  </el-col>
			  <el-col :span="8">
				<div class="wrapper">
					<div class="icon"><i class="iconfont icon-guanzhu"></i></div>
					<div>
						<div class="title">每日获得关注数</div>
						<div class="jifen"><span>积分 +10</span><span>已完成 0/2</span></div>
					</div>
					<div class="btn">
						<el-button type="warning" size="mini" class="submit" @click="$router.push({path:'/social/form'})">去发布</el-button>
					</div>
				</div>
			  </el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
import EventBus from '@/utils/eventHub.js'
import { getnewTask } from '@/api/personal/fuli'
export default {
  data () {
    return {
      url:'',
	  newList:[]
    }
  },
  methods: {
    async getData(){
    	const res = await getnewTask()
    	if (res.code === 0) {
			this.newList = res.data
    		
    	} else {
    	  this.$message.error(res.msg)
    	}
    },
  },
  mounted () {
	this.getData() 
  }

}
</script>

<style lang="scss" scoped>
.task-wrapper{
	padding: 30px 40px;
	box-sizing: border-box;
	.title.page{
		font-size: 20px;
		font-weight: 800;
		border-bottom: 1px solid #D4D4E6;
		padding-bottom: 10px;
		.rule-btn{
			color: #585B61;
			float: right;
			font-size: 14px;
			font-weight: 500;
			cursor: pointer;
			.iconfont{
				margin-right: 5px;
			}
		}
	}
	.newTask{
		margin-top: 20px;
		display: flex;
		flex-wrap: wrap;
			.wrapper{
				flex: 0 0 46%;
				border: 1px solid #DDDDDD;
				border-radius: 5px;
				margin: 8px 0;
				padding: 12px;
				&:nth-child(odd){
					margin-right: 1%;
				}
				&>div{
					display: inline-block;
					vertical-align: top;
					margin-right: 8px;
				}
				.icon{
					background-color: #FEF7EA;
					border-radius: 50%;
					width: 40px;
					height: 40px;
					display: inline-flex;
					justify-content: center;
					align-items: center;
					.iconfont{
						color: #FF842E;
						font-size: 26px;
					}
				}
				.title{
					font-size: 16px;
					font-weight: 800;
				}
				.jifen{
					color: #8B8B8B;
					font-size: 12px;
					.num{
						color: #FF842E;
						display: inline-block;
						margin-left: 5px;
					}
				}
				.btn{
					float: right;
					margin-top: 8px;
					.el-button--warning{
						background-color: #FF842E;
						border-radius: 20px;
					}
					.el-button--info{
						background-color: #c8c9cc;
						color: #585B61;
						border-radius: 20px;
					}
				}
			}

		
	}
	&.daytask{
		.dayTaskList{
			margin-top: 20px;
			display: flex;
			flex-wrap: wrap;
			.wrapper{
				flex: 0 0 29.3%;
				border: 1px solid #DDDDDD;
				border-radius: 5px;
				margin: 8px 0;
				padding: 12px;
				margin-right: 1%;
				&:nth-child(3n){
					margin-right: 0;
				}
				.icon{
						
					width: 30px;
					height: 30px;
					
					.iconfont{
						color: #FF842E;
						font-size: 20px;
					}
				}
				.title{
					font-size: 14px;
				}
				.jifen{
					color: #8B8B8B;
					font-size: 12px;
					span:last-child{
						display: inline-block;
						margin-left: 5px;
					}
				}
				.btn{
					float: right;
					margin-top: 8px;
					.el-button--warning{
						background-color: #FF842E;
						border-radius: 20px;
					}
					.el-button--info{
						background-color: #c8c9cc;
						color: #585B61;
						border-radius: 20px;
					}
				}
			}

		}		
	}
	&.daytask{
		.el-row{
			margin-top: 20px;
		
			.el-col{
				.wrapper{
					border: 1px solid #DDDDDD;
					padding: 12px 8px;
					&>div{
						display: inline-block;
						vertical-align: top;
						margin-right: 8px;
					}
					.icon{
						
						width: 30px;
						height: 30px;
						
						.iconfont{
							color: #FF842E;
							font-size: 20px;
						}
					}
					.title{
						font-size: 14px;
					}
					.jifen{
						color: #8B8B8B;
						font-size: 12px;
						span:last-child{
							display: inline-block;
							margin-left: 5px;
						}
					}
					.btn{
						float: right;
						margin-top: 8px;
						.el-button--warning{
							background-color: #FF842E;
							border-radius: 20px;
						}
						
					}
				}
		
			}
		}
	}
}	

</style>